function initilizeSwiper(container) {
	// eslint-disable-next-line no-magic-numbers
	const slidesPerView = Math.min(5, container.dataset.sizes);
	// eslint-disable-next-line no-undef
	new Swiper('.swiper.product-' + container.dataset.id, {
		direction: 'vertical',
		slidesPerView: slidesPerView,
		initialSlide: 1,
		centeredSlides: 'center',
		centeredSlidesBounds: 'center',
		// Navigation arrows
		navigation: {
			nextEl: '.swiper.product-' + container.dataset.id + ' .swiper-button-prev',
			prevEl: '.swiper.product-' + container.dataset.id + ' .swiper-button-next',
		},
	});
}
document.querySelectorAll('.sizes-container').forEach(initilizeSwiper);
